import { useCallback, useEffect, useState } from "react";
import ImpoundsTypeService from "../../../../../../../../../../../services/administration/impounds";
import { IImpoundsTypeExtended } from "../../../../../../../../../../../types/Impounds";

export const useFetchImpoundTypes = () => {
  const [isTypesLoading, setIsTypesLoading] = useState<boolean>(false);

  const [types, setTypes] = useState<{ value: string; label: string }[]>();

  const fetchTypes = useCallback(() => {
    setIsTypesLoading(true);

    ImpoundsTypeService.fetchAll()
      .then((res: any) => {
        const typesArr = res.map((item: IImpoundsTypeExtended) => ({
          value: item.id,
          label: item.name
        }));
        setTypes(typesArr);
        setIsTypesLoading(false);
      })
      .catch(() => setIsTypesLoading(false));
  }, []);

  useEffect(() => {
    fetchTypes();
  }, [fetchTypes]);

  return { types, isTypesLoading };
};
